import { render } from "./FooterLink.vue?vue&type=template&id=68f3339b&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=68f3339b&lang=scss&scoped=true"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f3339b"]])

export default __exports__